import { createFileRoute, redirect } from '@tanstack/react-router';
import { ANALYTICS_RANGE_PRESETS, type AnalyticsRangePreset } from '@repo/shared/marketing';
import { OFFER_FRIENDS_ANCHOR } from '@/features/new-client-offer/setup/offer-setup-anchors';

type OldOverviewSearch = { range?: AnalyticsRangePreset };

/**
 * Old Refer a Friend Overview → the friends results on New Client Offer › Overview, keeping a bookmarked period
 * (`?range=90d`; the same presets). No side effects: hover preload runs it.
 */
export const Route = createFileRoute('/_auth/$orgId/marketing/referrals/')({
  validateSearch: (search: Record<string, unknown>): OldOverviewSearch => ({
    range:
      typeof search.range === 'string' && (ANALYTICS_RANGE_PRESETS as readonly string[]).includes(search.range)
        ? (search.range as AnalyticsRangePreset)
        : undefined,
  }),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/$orgId/marketing/new-client-offer',
      params: { orgId: params.orgId },
      search: { range: search.range },
      hash: OFFER_FRIENDS_ANCHOR,
      replace: true,
    });
  },
});
